<script>
    import Spinner from "svelte-spinner";
    import { fade, blur } from "svelte/transition";
    import { createEventDispatcher, onDestroy, onMount } from "svelte";
    import { axiosInst } from "../credentials";
    import { selectedOrgDTO, loggedFromClient } from "../ui-store";
    import { PlusIcon, FrownIcon, CheckIcon, DownloadIcon, Trash2Icon } from "svelte-feather-icons";
    import Search from "./SearchComponent.svelte";
    import { paginate, LightPaginationNav } from 'svelte-paginate'
    import { fileUploadToUserProfile, downloadFileFromProcess, removeDocumentFromUser } from "../services/userDocumentsService";
    // Import the toast function
    import bulmaToast from "bulma-toast";
    
    //import meomentjs and set locale to greek
    import moment from "moment";
    import 'moment/locale/el'  // without this line it didn't work
    moment.locale('el')

    export let userDocuments = [];
    export let userTaxId = null;
    export let userId = null;

    const installation = process.env.ENV;

    let deleteMessage = null;

    $: if (deleteMessage !== null) {
      bulmaToast.setDoc(window.document);

      bulmaToast.toast({
      message: deleteMessage,
      position: "top-right",
      dismissible: false,
      animate: { in: "fadeIn", out: "fadeOut" },
      duration: 5000,
      type: deleteMessage.includes("Επιτυχής") ? 'is-success' : 'is-danger' 
      });
      
      setTimeout(() => {
          deleteMessage = null;
        }, 5000);
      // bulmaToast.show();
    }

    let successfulUpload = null;
    let successfulDelete = null;
    let documentToBeDeleted = null;

    let loadingSearch = true;
    let loadingUpload = false;
    let loadingDelete = false;
    let paginatedItems = [];

    
    let filteredResults = [];

    let fileData = {
        "registeredOrganizationId": installation === "pdm" ? 1 : null,
        "userTaxId": userTaxId,
        "fileTitle": "",
        "fileDescription": ""
    }
    
    // userDocuments =
    // [
    //     {
    //         "fileTitle": "Αίτηση",
    //         "fileDescription": "Αίτηση",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc6ee",
    //         "uploadDate": "2023-09-28 21:00:00.000000"
    //     },
    //     {
    //         "fileTitle": "Υπεύθυνη δήλωση",
    //         "fileDescription": "Υπεύθυνη δήλωση",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc6fa",
    //         "uploadDate": "2023-09-28 23:00:00.000000"
    //     },
    //     {
    //         "fileTitle": "Ληξιαρχική πράξη γέννησης",
    //         "fileDescription": "Ληξιαρχική πράξη γέννησης",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc6f6",
    //         "uploadDate": "2023-09-28 15:21:00.000000"
    //     },
    //     {
    //         "fileTitle": "Αποδεικτικό Κατοικίας",
    //         "fileDescription": "Αποδεικτικό Κατοικίας",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc702",
    //         "uploadDate": "2023-09-28 09:10:00.000000"
    //     },
    //     {
    //         "fileTitle": "Αγγελία γάμου",
    //         "fileDescription": "Αγγελία γάμου",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc6f2",
    //         "uploadDate": "2023-09-28 21:00:00.000000"
    //     },
    //     {
    //         "fileTitle": "Δελτίου ταυτότητας του/της μέλλοντος συζύγου",
    //         "fileDescription": "Δελτίου ταυτότητας του/της μέλλοντος συζύγου",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc70e",
    //         "uploadDate": "2023-09-28 21:00:00.000000"
    //     },
    //     {
    //         "fileTitle": "Παράβολα Χαρτοσήμου",
    //         "fileDescription": "Παράβολα Χαρτοσήμου",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc70a",
    //         "uploadDate": "2023-09-28 21:00:00.000000"
    //     },
    //     {
    //         "fileTitle": "Πιστοποιητικό Οικογενειακής Κατάστασης του/της μέλλοντος συζύγου",
    //         "fileDescription": "Πιστοποιητικό Οικογενειακής Κατάστασης του/της μέλλοντος συζύγου",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc706",
    //         "uploadDate": "2023-09-28 21:00:00.000000"
    //     },
    //     {
    //         "fileTitle": "Πιστοποιητικό Οικογενειακής Κατάστασης",
    //         "fileDescription": "Πιστοποιητικό Οικογενειακής Κατάστασης",
    //         "versionedFileId": "62d7e85cf86bc169bd2dc704",
    //         "uploadDate": "2023-09-28 21:00:00.000000"
    //     },
    //     {
    //         "fileTitle": "Δελτίο ταυτότητας",
    //         "fileDescription": "Δελτίο ταυτότητας",
    //         "versionedFileId": "62d7e85df86bc169bd2dc712",
    //         "uploadDate": "2023-09-28 21:00:00.000000"
    //     }
    // ];
    export let currentPage = 1;

    //initial pagination range is always 1-4
    let paginationFrom = 1;
    let paginationTo = 4;
    let pages = [];
    let selectedPage = [];

    let resultsPerPage = 3;
    let totalPages = 0;

    let fileToUpload = null;
    
    // $:totalPages = Math.ceil(userDocuments.length / resultsPerPage);
    $: console.log(paginatedItems);
    // $: if (userDocuments.length) paginatedItems = paginate({ userDocuments, resultsPerPage, currentPage })

    let openfileuploadmodal = false;

    const toggleFileUploadModal = () => {
        successfulUpload = null;
        openfileuploadmodal = !openfileuploadmodal;
    };

    const handleUpload = async () => {
        try {
            loadingUpload = true;
            let updateUser = await fileUploadToUserProfile(fileToUpload, fileData);
            loadingUpload = false;
            successfulUpload = "success";
            filteredResults = updateUser.userDocuments;
            filteredResults = filteredResults.sort(
                            (a, b) => parseInt(b.id) - parseInt(a.id)
                            );
            paginatedItems = paginate({ items: filteredResults, pageSize:resultsPerPage , currentPage: 1 });
            // toggleFileUploadModal();
        }
        catch(error) {
            console.log(error);
            loadingUpload = false;
            successfulUpload = "failure";
        }
    }

    const handleDocumentDelete = async (documentId) => {
        try {
            documentToBeDeleted = documentId;
            loadingDelete = true;
            let updateUser = await removeDocumentFromUser(userId, documentId);
            loadingDelete = false;
            successfulDelete = "success";
            documentToBeDeleted = null;
            filteredResults = updateUser.userDocuments;
            filteredResults = filteredResults.sort(
                            (a, b) => parseInt(b.id) - parseInt(a.id)
                            );
            paginatedItems = paginate({ items: filteredResults, pageSize:resultsPerPage , currentPage: 1 });
            // toggleFileUploadModal();
        }
        catch(error) {
            console.log(error);
            loadingDelete = false;
            successfulDelete = "failure";
            deleteMessage = "Παρουσιάστηκε πρόβλημα. Παρακαλώ προσπαθήστε αργότερα.";
            documentToBeDeleted = null;
        }
    }

    
    //preload organization
    let registeredFromProcessOrg;
    const loadOrg = async () => {

        return new Promise(async (resolve, reject) => {
        $axiosInst
            .get("registeredOrganization/" + $loggedFromClient)
            .then(function (response) {
            if (response.status !== 200) {
                console.log(
                "Looks like there was a problem. Status Code: " + response.status
                );
                // isLoading = false;
                reject();
            }
            // Examine the text in the response
            else {
                console.log("loadOrgs response: ", response.data.data);
                registeredFromProcessOrg = response.data.data.id;
                fileData.registeredOrganizationId = registeredFromProcessOrg;
       
                // isLoading = false;
                resolve();
            }
            })
            .catch(function (err) {
            console.log("Fetch Error :-S", err);
            isLoading = false;
            reject();
            });
        });
    };

    onMount(() => {
        loadOrg();
        // moment.lang("de").format('LLL');
        filteredResults = userDocuments;
        filteredResults = filteredResults.sort(
                            (a, b) => parseInt(b.id) - parseInt(a.id)
                            );
        paginatedItems = paginate({ items: filteredResults, pageSize:resultsPerPage , currentPage: 1 });
        selectedPage = pages[0];
    })
</script>

    <div class="mx-12 my-4">
        <div class="columns is-align-items-center">
            <div class="column is-four-fifths">
                <Search
                    items={userDocuments}
                    filtersArray={[
                        "fileTitle",
                        "fileDescription"
                    ]}
                    on:ready={(e) => {
                        console.log("search says it's ready");
                        filteredResults = e.detail.results;
                        filteredResults = filteredResults.sort(
                            (a, b) => parseInt(b.id) - parseInt(a.id)
                            );
                        //paginate again
                        paginatedItems = paginate({ items: filteredResults, pageSize:resultsPerPage , currentPage: 1 });
                        loadingSearch = false;
                    }}
                    on:loading={() => {
                        loadingSearch = true;
                    }}
                />
            </div>
            <div class="column">
                <label for="upload">
                    <span class="button is-disabled is-medium is-link is-dark">
                        <PlusIcon size="24"/>&nbsp;&nbsp;Προσθήκη νέου
                    </span>
                    <!-- disabled -->
                    <input
                        bind:files={fileToUpload}
                        onclick="this.value=null"
                        on:change={() => {
                            if (fileToUpload.length > 0) {
                                console.log(fileToUpload);
                                fileData.fileTitle = fileToUpload[0].name;
                                fileData.fileDescription = "";
                                toggleFileUploadModal(); //open modal
                            }
                        }}
                        style="display:none;"
                        type="file"
                        id="upload"
                    />
                </label>
            </div>
        </div>
        
  </div>
    {#if !filteredResults || (filteredResults && filteredResults.length == 0)}
        Δεν έχετε καταχωρισμένα έγγραφα
    {:else}
        <div class="my-nav">
        <LightPaginationNav
            totalItems={filteredResults.length}
            pageSize={resultsPerPage}
            currentPage={currentPage}
            limit=1
            showStepOptions=true
            on:setPage={(e) => {
                console.log(e);
                currentPage = e.detail.page; 
                paginatedItems = paginate({ items: filteredResults, pageSize:resultsPerPage , currentPage: e.detail.page });
                }}
            />
        </div>

        <table class="table is-fullwidth is-narrow responsive-table mt-3">
            <thead
              style="position:sticky; top:0rem; z-index: 1;"
              class="is-hidden-mobile rounded-white"
            >
            <tr>
              <th class="has-text-centered" scope="col" colspan="2" style="width: 25%">
                <div class="is-sr-only">Όνομα</div>
              </th>
              <th class="has-text-centered" scope="col" colspan="3" style="width: 45%">
                <div class="is-sr-only">Περιγραφή</div>
              </th>
              <th class="has-text-centered" scope="col" colspan="2" style="width: 30%">
                <div class="is-sr-only">Ημερομηνία μεταφόρτωσης</div>
              </th>
            </tr>
            </thead>
            <tbody>
                {#each paginatedItems as item}
                <tr
                    style="width:100%"
                    class="my-hoverable is-mobile is-vcentered is-size-5-desktop is-size-6-tablet has-text-weight-medium is-size-7-mobile p-4 has-text-left"
                >
                    <td
                        style="width: 25%"
                        class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-left p-3 pt-5"
                    >
                        <!-- {item.fileTitle} -->
                        <a
                            class="is-primary is-light has-text-weight-normal"
                             on:click={downloadFileFromProcess(item, fileData.registeredOrganizationId, "")}
                            data-tooltip="tooltip"
                        >
                            <div>
                                <span class="b-1">{item.fileTitle}</span>&nbsp;&nbsp;<DownloadIcon size="1.5x" />
                            </div></a
                        >
                    </td>

                    <td
                        style="width: 45%"
                        class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-left p-3 pt-5"
                    >
                        {item.fileDescription}
                    </td>
                    <td
                        style="width: 30%"
                        class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-left p-3 pt-5"
                    >   {moment(
                        item.uploadDate.split(" ")[0],
                            "yyyy-MM-DD"
                        ).format("dddd, Do MMMM YYYY")}
                        <br>
                        {moment(item.uploadDate.split(" ")[1], "HH:mm:ss").format(
                            "h:mm A"
                      )}
                        <!-- {item.uploadDate} -->
                    </td>
                    <td
                        style="width: 30%"
                        class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-left p-3 pt-5"
                    > 
                    {#if documentToBeDeleted === item.id}
                        <Spinner size="25" speed="750" thickness="2" gap="40" />
                    {:else}
                        <a
                            class="has-text-weight-normal has-text-danger"
                            on:click={handleDocumentDelete(item.id)}
                            data-tooltip="tooltip"
                        >
                            <div>
                                <Trash2Icon size="1.5x" />
                            </div></a
                        >
                    {/if}
                    </td>
                </tr>
                {/each}
            </tbody>
        </table>

    {/if}

    {#if openfileuploadmodal}
        <div class="modal is-active">
            <div class="modal-background"/>
            <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {#if loadingUpload}
                        Μεταφόρτωση σε εξέλιξη...
                    {:else}
                        Μεταφόρτωση αρχείου
                    {/if}
                </p>
            </header>
            <section class="modal-card-body is-size-5-desktop is-size-6">
                {#if loadingUpload}
                    <div in:fade|local class="has-text-centered">
                        <div class="level">
                            <div class="level-item has-text-centered">
                            <Spinner size="100" speed="750" thickness="2" gap="40" />
                            </div>
                        </div>
                    </div>
                {:else}
                    {#if !successfulUpload}
                        <div class="field is-horizontal">
                            <div class="field-body">
                            <div class="field mt-0">
                                <div class="control">
                                <input
                                    bind:value={fileData.fileTitle}
                                    class="input"
                                    type="text"
                                />
                                </div>
                            </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label" for={"desc"}>
                                Περιγραφή
                            </label>
                            <div class="field-body">
                            <div class="field mt-0">
                                <div class="control">
                                    <textarea
                                    id="desc"
                                    class="textarea"
                                    bind:value={fileData.fileDescription}
                                />
                                </div>
                            </div>
                            </div>
                        </div>
                    {:else if successfulUpload==="success"}
                        <div in:fade|local class="has-text-centered">
                            <div class="is-size-4-mobile is-size-3 has-text-success">
                            <CheckIcon size="50" aria-hidden="true" />
                            </div>
                            <div class="columns is-centered mt-2">
                                <div class="column is-half">
                                    <div class="is-size-6-mobile is-size-5">
                                    Επιτυχής μεταφόρτωση!
                                    </div>
                                </div>
                            </div>
                        </div>
                    {:else if successfulUpload==="failure"}
                        <div in:fade|local class="has-text-centered">
                            <div class="is-size-4-mobile is-size-3">
                                <FrownIcon size="50" aria-hidden="true" />
                            </div>
                            <div class="columns is-centered mt-2">
                                <div class="column is-half">
                                    <div class="is-size-6-mobile is-size-5">
                                    Παρουσιάστηκε πρόβλημα κατά τη μεταφόρτωση του αρχείου
                                    σας.
                                    </div>
                                    <div class="is-size-6-mobile is-size-5">
                                    Παρακαλώ προσπαθήστε ξανά.
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/if}
                {/if}
            </section>
            <footer class="modal-card-foot is-grouped level">
                <button
                disabled={loadingUpload}
                class="button is-link has-background-link-dark is-size-5-desktop is-size-6"
                on:click={toggleFileUploadModal}>
                {#if !successfulUpload}
                    Άκυρο
                {:else}
                    Κλείσιμο
                {/if}
                </button>
                {#if !successfulUpload}
                    <button
                    disabled={!fileData.fileTitle || loadingUpload}
                    class="button is-link has-background-link-dark is-size-5-desktop is-size-6"
                    on:click={handleUpload}
                        >Μεταφόρτωση</button
                    >
                {/if}
            </footer>
            </div>
            <button
            class="modal-close is-large"
            aria-label="close"
            on:click={toggleFileUploadModal}
            />
        </div>
    {/if}
<style>
    .my-nav :global(.pagination-nav) {
        box-shadow: 0 0px 0px rgba(255, 255, 255, 0) !important;
    }
</style>
  